import { z } from 'zod';
var Address = /** @class */ (function () {
    function Address() {
    }
    return Address;
}());
export { Address };
export var AddressSchema = z.object({
    address: z.string().optional(),
    number: z.string().optional(),
    zipCode: z.string().max(9).optional(),
    district: z.string().optional(),
    complement: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional()
});
